import React from 'react'
import { Button } from '@/components/ui/button'
import { User, Briefcase, Settings, FileText, LucideIcon } from 'lucide-react'

interface Tab {
  id: 'profile' | 'interests' | 'inquiries' | 'settings'
  label: string
  icon: LucideIcon
}

interface ProfileTabsProps {
  activeTab: 'profile' | 'interests' | 'inquiries' | 'settings'
  onTabChange: (tabId: 'profile' | 'interests' | 'inquiries' | 'settings') => void
  className?: string
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ 
  activeTab, 
  onTabChange, 
  className 
}) => {
  const tabs: Tab[] = [
    { id: 'profile', label: 'Profile Information', icon: User },
    { id: 'interests', label: 'Investment Interests', icon: Briefcase },
    { id: 'inquiries', label: 'My Inquiries', icon: FileText },
    { id: 'settings', label: 'Settings', icon: Settings },
  ]

  return (
    <div className={`flex gap-2 overflow-x-auto ${className}`}>
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          variant={activeTab === tab.id ? "default" : "outline"}
          className="flex items-center gap-2 whitespace-nowrap"
        >
          <tab.icon size={16} />
          {tab.label}
        </Button>
      ))}
    </div>
  )
}

export default ProfileTabs
